/**
 * @generated SignedSource<<a54a4b8b7f4aec08d7a216d42763ec06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type editorViewRendererFragment$data = {
  readonly adf: string | null;
  readonly elementType: {
    readonly mediaConfig: {
      readonly asapIssuer: string;
      readonly mediaCollectionName: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  };
  readonly " $fragmentType": "editorViewRendererFragment";
};
export type editorViewRendererFragment$key = {
  readonly " $data"?: editorViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editorViewRendererFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "helpCenterAri"
    }
  ],
  "kind": "Fragment",
  "name": "editorViewRendererFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "adf"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "parentAri",
                  "variableName": "helpCenterAri"
                }
              ],
              "concreteType": "HelpLayoutMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "mediaCollectionName"
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "mediaToken"
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "mediaUrl"
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "asapIssuer"
                  },
                  "action": "THROW"
                }
              ]
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "HelpLayoutEditorElement"
};

(node as any).hash = "7185bbf55e8e3c72d62297a3cc6f9712";

export default node;
